import React, { useContext } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import classNames from "classnames";
import { THEME_SETTINGS } from "@theme-settings";
import { MyBetsStoreContext } from "@state/context/my-bets/MyBetsStoreContext";
import { Bet } from "@models";

export default observer(function ShareBetSlipButton(props: {
	bet: Bet;
	btnTiny?: boolean;
	betSlip?: boolean;
	label?: boolean;
}) {
	const { t } = useTranslation("mybets");
	const { label = true } = props;

	const store = useContext(MyBetsStoreContext);

	if (!THEME_SETTINGS.features.isBetSlipShareEnabled) {
		return null;
	}

	if (store == null) {
		return null;
	}

	const btnClasses = classNames("btn btn--icon", {
		"btn--xtny btn--tertiary": props.btnTiny,
		"bet__btn btn--wrap btn--wrap--base btn--block btn--primary--inverted":
			!props.btnTiny,
		"bet__btn--slip": props.betSlip,
	});

	const iconClasses = classNames("u-icon u-icon--share", {
		"u-icon--tny": props.btnTiny,
		"u-icon--sml": !props.btnTiny,
	});

	return (
		<>
			<button
				type="button"
				className={btnClasses}
				onClick={() => {
					store.shareBetSlipStore.showPopup(props.bet);
				}}
			>
				<i className={iconClasses}></i>
				{label && (
					<label className="bet__btn__label">
						{t("SHARE.BUTTON_LABEL")}
					</label>
				)}
			</button>
		</>
	);
});
